// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blog-detail {
	background: #ebebeb;
	padding: 50px 0px;
}
.blog-meta {
	display: flex;
	align-items: center;
	height: 100%;
}
.blog-title {
	font-size: 60px;
	line-height: 1.2;
	font-weight: 600;
	margin: 0px 0px 10px;
}
.metadata {
	color: #32aa27;
	font-size: 16px;
	font-weight: bold;
}
.blog-detail h4 {
	font-size: 1.5rem;
	padding-left: 20px;
	padding-right: 20px;
	margin-bottom: 10px;
	border-left: 5px solid #32aa27;
}
.blog-detail p {
	margin-bottom: 5px;
	text-align: justify;
}
.blog-detail p  br{
	display: none;
}
.blog-detail ul {
    margin: 0;
}
.next-previous {
	display: flex;
	justify-content: space-between;
}
.next-previous {
	align-items: center;
	display: flex;
}
@media only screen and (max-width: 1199px) {
	.blog-title {
		font-size: 50px;
	}
}
@media only screen and (max-width: 991px) {
	.blog-title {
		font-size: 40px;
	}
}
@media only screen and (max-width: 767px) {
	.blog-title {
		font-size: 30px;
	}
}`, "",{"version":3,"sources":["webpack://./src/pages/general/blogdetail/BlogDetail.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,iBAAiB;AAClB;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,YAAY;AACb;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,oBAAoB;AACrB;AACA;CACC,cAAc;CACd,eAAe;CACf,iBAAiB;AAClB;AACA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;CACnB,mBAAmB;CACnB,8BAA8B;AAC/B;AACA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,aAAa;AACd;AACA;IACI,SAAS;AACb;AACA;CACC,aAAa;CACb,8BAA8B;AAC/B;AACA;CACC,mBAAmB;CACnB,aAAa;AACd;AACA;CACC;EACC,eAAe;CAChB;AACD;AACA;CACC;EACC,eAAe;CAChB;AACD;AACA;CACC;EACC,eAAe;CAChB;AACD","sourcesContent":[".blog-detail {\n\tbackground: #ebebeb;\n\tpadding: 50px 0px;\n}\n.blog-meta {\n\tdisplay: flex;\n\talign-items: center;\n\theight: 100%;\n}\n.blog-title {\n\tfont-size: 60px;\n\tline-height: 1.2;\n\tfont-weight: 600;\n\tmargin: 0px 0px 10px;\n}\n.metadata {\n\tcolor: #32aa27;\n\tfont-size: 16px;\n\tfont-weight: bold;\n}\n.blog-detail h4 {\n\tfont-size: 1.5rem;\n\tpadding-left: 20px;\n\tpadding-right: 20px;\n\tmargin-bottom: 10px;\n\tborder-left: 5px solid #32aa27;\n}\n.blog-detail p {\n\tmargin-bottom: 5px;\n\ttext-align: justify;\n}\n.blog-detail p  br{\n\tdisplay: none;\n}\n.blog-detail ul {\n    margin: 0;\n}\n.next-previous {\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n.next-previous {\n\talign-items: center;\n\tdisplay: flex;\n}\n@media only screen and (max-width: 1199px) {\n\t.blog-title {\n\t\tfont-size: 50px;\n\t}\n}\n@media only screen and (max-width: 991px) {\n\t.blog-title {\n\t\tfont-size: 40px;\n\t}\n}\n@media only screen and (max-width: 767px) {\n\t.blog-title {\n\t\tfont-size: 30px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
